import { render, staticRenderFns } from "./PositionsEdit.vue?vue&type=template&id=36c03d53&scoped=true&"
import script from "./PositionsEdit.vue?vue&type=script&lang=js&"
export * from "./PositionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c03d53",
  null
  
)

export default component.exports